import { render, staticRenderFns } from "./TaxStandard.vue?vue&type=template&id=5d559c36"
import script from "./TaxStandard.vue?vue&type=script&lang=js"
export * from "./TaxStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports